import { render, staticRenderFns } from "./similarity-groups-upload.vue?vue&type=template&id=a6fbaef4&scoped=true"
import script from "./similarity-groups-upload.vue?vue&type=script&lang=js"
export * from "./similarity-groups-upload.vue?vue&type=script&lang=js"
import style0 from "./similarity-groups-upload.vue?vue&type=style&index=0&id=a6fbaef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fbaef4",
  null
  
)

export default component.exports